import {inject, observer} from 'mobx-react';
import './index.scss';
import {useEffect, useRef} from 'react';

const VideoModal = (props) => {
    const {video = {}, toggleVideo, className} = props;
    const lVideo = video.video;
    const cover = video.cover;
    const videoRef = useRef(null);
    useEffect(() => {
        let activeVideo;
        if(!videoRef.current && lVideo.url) {
            activeVideo = document.querySelector('[data-video="0"]');
            activeVideo.play();
        }
        videoRef.current = lVideo;
    }, [lVideo]);
    return (
        <div className={`m-video-modal ${className}`}>
            <div className="bg">
                <div className="yo-ico close" onClick={() => {
                    toggleVideo({});
                }}>&#xf3f4;</div>
            </div>
            <video
                preload={'true'}
                controls={true}
                controlslist={`${hysdk.sniff.ios ? '' : 'nodownload'}`}
                x5-playsinline={'true'}
                webkit-playsinline={'true'}
                playsinline={'true'}
                poster={cover.url}
                data-video="0"
                className="active"
            >
                <source src={lVideo.url} type="video/mp4" />
            </video>
        </div>
    );
};

export default inject(({store}) => {
    return {
        video: store.video,
        toggleVideo: store.toggleVideo,
        loadVideo: store.loadVideo
    };
})(observer((props) => {
    if(!props.video?.video?.url) return null;
    return ReactDOM.createPortal(<VideoModal className={!props.video.video.url ? 'hide' : ''} {...props}/>, document.querySelector('body'));
}));